import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconWindow"><Path d="M3.75 10.75V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V10.75M3.75 10.75V17.25C3.75 18.9069 5.09315 20.25 6.75 20.25H17.25C18.9069 20.25 20.25 18.9069 20.25 17.25V10.75M3.75 10.75H20.25M10.75 7.25H17.25M8.25 7.25C8.25 7.66421 7.91421 8 7.5 8C7.08579 8 6.75 7.66421 6.75 7.25C6.75 6.83579 7.08579 6.5 7.5 6.5C7.91421 6.5 8.25 6.83579 8.25 7.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconWindow;
